import { createContext } from 'react';

const classNamePolarisSummerEditions2023 = 'Polaris-Summer-Editions-2023';
const classNamePolarisSummerEditions2023ShadowBevelOptOut = 'Polaris-SE23-Shadow-Bevel-Opt-Out';
const FeaturesContext = /*#__PURE__*/createContext(undefined);

export { FeaturesContext, classNamePolarisSummerEditions2023, classNamePolarisSummerEditions2023ShadowBevelOptOut };
